import React, { useState, useEffect } from "react";
import classes from "./Event.module.css";
import { useParams } from "react-router";
import axios from "../../../EventDownloader";
import Modal from "../../../components/UI/Modal/Modal";
import EventDetail from "./EventDetail";

const Event = props => {
    const [loading, setLoading] = useState(true);
    const [found, setFound] = useState(false);
    const [eventDetail, setEventDetail] = useState(null);
    const { id } = useParams();

    useEffect(() => {
        const baseName = id.endsWith("_1") || id.endsWith("_2") ? id.substr(0, 6) : id;

        axios.get("/files.json").then(
            resp => {
                setFound(resp.data.includes(baseName + ".json"));
                if (resp.data.includes(baseName + ".json")) {
                    setEventDetail(<EventDetail filename={id + ".json"} headline={id.substr(0, 2) + "-" + id.substr(2, 2) + "-" + id.substr(4, 2)} />)
                }
                setLoading(false);
            }
        ).catch(error => {
            setLoading(false);
            setFound(false);
            console.log(error);
        });
    }, [id]);

    return (
        <>
            <h1>Pokémon Sword & Shield - Event {id.substr(0, 2) + "-" + id.substr(2, 2) + "-" + id.substr(4, 2)}</h1>
            <Modal show={loading} />
            {!loading && !found ? <div className={classes.Error}>Event Not Found</div> : eventDetail}
        </>
        )
}

export default Event; 